module.exports = __webpack_public_path__ + "media/images/sandbox/sailormoon-ce7ed68a74f0bcf3fae6409ff1d6bedc.png";